(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mcs-article-reading"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mcs-article-reading')) {
    customElements.define('mcs-article-reading', class extends HTMLElement {
      connectedCallback() {
        this.disconnectedCallback();
        this.target = document.getElementById(this.dataset.target);
        if (!this.target) return;
        this.abort = new AbortController();
        const schedule = () => { if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); }); };
        window.addEventListener('scroll', schedule, { passive: true, signal: this.abort.signal });
        window.addEventListener('resize', schedule, { signal: this.abort.signal });
        this.observer = new ResizeObserver(schedule);
        this.observer.observe(this.target);
        this.hidden = false;
        this.update();
      }
      update() {
        const rect = this.target.getBoundingClientRect();
        const viewport = window.innerHeight;
        const distance = rect.height - viewport;
        const progress = distance > 0 ? Math.max(0, Math.min(1, -rect.top / distance)) : (rect.bottom <= viewport ? 1 : 0);
        this.firstElementChild.style.transform = `scaleX(${progress})`;
        this.setAttribute('aria-valuenow', String(Math.round(progress * 100)));
      }
      disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); cancelAnimationFrame(this.frame); this.frame = null; }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mcs-buy-personalization"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mcs-buy-personalization')) {
  customElements.define('mcs-buy-personalization', class extends HTMLElement {
    connectedCallback() {
      if(this.ready)return;this.ready=true;
      this.owner=this.closest('mcs-buy-list');this.dialog=this.querySelector('dialog');this.form=this.querySelector('form');
      this.fields=this.querySelector('[data-personal-fields]');this.error=this.querySelector('[data-personal-error]');this.save=this.querySelector('[data-personal-save]');
      this.copy=JSON.parse(this.querySelector('[data-personal-copy]').textContent);this.prices=new Map();this.sequence=0;
      this.querySelector('[data-personal-close]').addEventListener('click',()=>this.dialog.close());
      this.dialog.addEventListener('click',event=>{if(event.target===this.dialog)this.dialog.close();});
      this.dialog.addEventListener('close',()=>{this.sequence++;this.opener?.focus({preventScroll:true});});
      this.form.addEventListener('submit',event=>{event.preventDefault();event.stopPropagation();this.commit();});
      this.form.addEventListener('input',()=>this.paintPrice());
      this.form.addEventListener('change',event=>{if(event.target.type==='file')this.uploadFile(event.target);else this.paintPrice();});
      this.owner.addEventListener('click',event=>{const button=event.target.closest('[data-personalize]');if(button){event.preventDefault();this.openRow(button.closest('[data-line-form]'),button);}});
      this.onLoad=()=>this.bindRows();window.addEventListener('load',this.onLoad,{once:true});this.bindRows();if(this.owner.ready)this.owner.render();
    }
    disconnectedCallback(){window.removeEventListener('load',this.onLoad);this.sequence++;}
    flat(elements) {
      return (elements||[]).flatMap(field=>field.hidden?[]:field.type==='group'?this.flat(field.elements):[field]);
    }
    schemaFor(productId) {
      const config=window.GPOConfigs;if(!config?.options)return null;
      const sets=Object.entries(config.options).sort((a,b)=>Number(b[0])-Number(a[0]));
      for(const [id,set] of sets){
        if(Number(set.status)!==0||set.published_scope&&!set.published_scope.includes('web'))continue;
        const rule=set.products?.rule;const manual=rule?.manual?.enable&&rule.manual.ids?.some(value=>String(value)===String(productId));
        if(!manual&&!rule?.all?.enable)continue;
        if(config.optionIds&&config.optionIds!=='all'&&!String(config.optionIds).split(',').includes(id))continue;
        if(!set.customers?.rule?.all?.enable)continue;
        if(set.countries?.enable){const included=set.countries.countries.includes(this.owner.dataset.country);if(included===(set.countries.type==='exclude'))continue;}
        const fields=this.flat(set.elements).filter(field=>field.required||/engrav|personali[sz]|logo/i.test(field.label+' '+field.label_on_cart));
        if(!fields.some(field=>['text','textarea','file'].includes(field.type)&&/engrav|personali[sz]|logo/i.test(field.label+' '+field.label_on_cart)))return null;
        if(fields.some(field=>!['text','textarea','file','image-swatches','image-dropdown','dropdown','checkbox','radio','buttons'].includes(field.type)||field.conditionalField))return null;
        return {id,fields};
      }
      return null;
    }
    bindRows() {
      if(!this.owner)return;
      this.owner.querySelectorAll('[data-line-form]').forEach(form=>{
        const schema=this.schemaFor(form.closest('[data-product-row]').dataset.productId);let button=form.querySelector('[data-personalize]');
        if(!schema){button?.remove();return;}
        if(!button){button=document.createElement('button');button.type='button';button.dataset.personalize='';button.className='mcs-buy__personalize';form.append(button);}
        button.textContent=schema.fields.some(field=>field.required)?this.copy.configure:this.copy.add;
        const option=form.querySelector('[data-variant]').selectedOptions[0];button.disabled=!option||option.disabled||this.owner.busy||!!this.owner.pending;
      });
    }
    needsConfiguration(form){return this.schemaFor(form.closest('[data-product-row]').dataset.productId)?.fields.some(field=>field.required)||false;}
    baseItem(form) {
      const option=form.querySelector('[data-variant]').selectedOptions[0],row=form.closest('[data-product-row]');
      return {id:option.value,productId:row.dataset.productId,noDiscount:row.dataset.noDiscount==='true',title:row.dataset.title,url:row.dataset.url,image:option.dataset.image||row.dataset.image,label:option.dataset.label,price:Number(option.dataset.price),quantity:Number(form.querySelector('[data-quantity]').value),min:Number(option.dataset.min)||1,step:Number(option.dataset.step)||1,max:Number(option.dataset.max)||null};
    }
    openRow(form,button) {
      if(!form||this.owner.busy||this.owner.pending||!form.reportValidity())return;
      const option=form.querySelector('[data-variant]').selectedOptions[0];if(!option||option.disabled)return;
      this.open(this.baseItem(form),button);
    }
    safeImage(asset) {
      if(!asset)return '';
      try {const url=new URL(asset.startsWith('http')?asset:(window.GPOConfigs?.fileUrl||'')+asset,location.origin);if(url.protocol==='https:'&&(url.origin===location.origin||url.hostname==='cdn.shopify.com'))return url.href;}catch{}return '';
    }
    async loadAddon(addon,refresh=false) {
      const id=String(addon.variant_id),handle=addon.product_handle;if(!/^\d+$/.test(id)||!handle)throw Error(this.copy.unavailable);
      const key=this.owner.currency+':'+this.owner.dataset.country+':'+handle;
      if(refresh)this.prices.delete(key);
      if(!this.prices.has(key))this.prices.set(key,fetch(this.owner.dataset.root+'products/'+encodeURIComponent(handle)+'.js',{credentials:'same-origin',headers:{Accept:'application/json'},cache:'no-store'}).then(async response=>{if(!response.ok)throw Error();return response.json();}).catch(error=>{this.prices.delete(key);throw error;}));
      const product=await this.prices.get(key),variant=product.variants?.find(value=>String(value.id)===id);
      if(!variant||!variant.available||!Number.isFinite(variant.price))throw Error(this.copy.unavailable);
      return {id,handle,price:variant.price};
    }
    isExample(field){return /example|preview/i.test(field.label)&&!(field.option_values||[]).some(value=>value.variant_id);}
    addonDefinitions(schema){return schema.fields.flatMap(field=>[field.addon_product,...(field.option_values||[])].filter(value=>value?.variant_id).map(value=>({field,value})));}
    async open(item,opener,asNew=false) {
      if(this.owner.busy||this.owner.pending)return;
      const schema=this.schemaFor(item.productId);if(!schema){this.owner.status.textContent=this.copy.unavailable;return;}
      this.opener=opener;this.draft=structuredClone(item);if(asNew)delete this.draft.key;
      this.schema=schema;this.fields.replaceChildren();this.error.textContent=this.copy.loading;this.save.disabled=true;this.uploading=0;this.addonPrices=new Map();
      this.querySelector('[data-personal-title]').textContent=item.title;this.querySelector('[data-personal-variant]').textContent=item.label+' · '+item.quantity+' '+this.owner.copy.units;
      this.querySelector('[data-personal-price]').textContent='';
      if(!this.dialog.open)this.dialog.showModal();const sequence=++this.sequence;
      try {
        const prices=await Promise.all(this.addonDefinitions(schema).map(async ({value})=>this.loadAddon(value)));
        if(sequence!==this.sequence)return;prices.forEach(value=>this.addonPrices.set(value.id,value));
        schema.fields.forEach(field=>this.renderField(field,item.personalization?.values?.[field.id]));
        this.error.textContent='';this.save.disabled=false;this.paintPrice();this.fields.querySelector('input,textarea,select')?.focus({preventScroll:true});
      }catch{if(sequence===this.sequence)this.error.textContent=this.copy.failed;}
    }
    renderField(field,value) {
      const wrapper=document.createElement('fieldset');wrapper.className='mcs-buy-personal__field';wrapper.dataset.fieldId=field.id;
      const title=document.createElement('legend');title.textContent=field.label+(field.required?' *':'');wrapper.append(title);
      const uid='buy-personal-'+this.sequence+'-'+field.id;
      if(this.isExample(field)){
        const details=document.createElement('details'),summary=document.createElement('summary');summary.textContent=field.label;details.append(summary);title.hidden=true;
        for(const option of field.option_values||[]){const src=this.safeImage(option.asset_name);if(src){const image=document.createElement('img');image.src=src;image.alt=option.value||field.label;image.loading='lazy';image.className='mcs-buy-personal__example';details.append(image);}}wrapper.append(details);
      }else if(['text','textarea'].includes(field.type)){
        const input=document.createElement(field.type==='textarea'?'textarea':'input');if(field.type==='text')input.type='text';input.id=uid;input.dataset.personalField=field.id;input.value=typeof value==='string'?value:'';input.placeholder=field.placeholder||'';input.required=!!field.required;
        if(Number(field.max_length)>0)input.maxLength=Number(field.max_length);if(Number(field.min_length)>0)input.minLength=Number(field.min_length);
        input.setAttribute('aria-label',field.label);wrapper.append(input);
      }else if(field.type==='file'){
        const input=document.createElement('input');input.type='file';input.id=uid;input.dataset.personalField=field.id;input.accept=(field.allowed_extensions||[]).map(ext=>'.'+ext).join(',');input.setAttribute('aria-label',field.label);input.dataset.uploaded=typeof value==='string'?value:'';wrapper.append(input);
        const note=document.createElement('p');note.className='mcs-buy-personal__help';note.dataset.uploadStatus='';note.textContent=value?this.copy.uploaded+' '+this.copy.replaceFile:'';wrapper.append(note);
      }else{
        const choices=document.createElement('div');choices.className='mcs-buy-personal__choices';
        for(const [index,option] of (field.option_values||[]).entries()){
          const label=document.createElement('label');label.className='mcs-buy-personal__choice';const input=document.createElement('input');input.type=field.allow_multiple?'checkbox':'radio';input.name=uid;input.value=String(index);input.dataset.personalField=field.id;input.checked=Array.isArray(value)&&value.includes(option.value);
          const src=this.safeImage(option.asset_name);if(src){const image=document.createElement('img');image.src=src;image.alt='';image.loading='lazy';label.append(image);}
          const caption=document.createElement('span');caption.textContent=option.value;
          if(option.variant_id){const price=this.addonPrices.get(String(option.variant_id));const cost=document.createElement('small');cost.textContent='+ '+this.owner.money(price.price)+' '+(field.advanced_addon==='one_time_charge'?this.copy.once:this.copy.perItem);caption.append(cost);}
          label.append(input,caption);choices.append(label);
        }wrapper.append(choices);
      }
      if(field.addon_product){const cost=document.createElement('p');cost.className='mcs-buy-personal__help';cost.textContent='+ '+this.owner.money(this.addonPrices.get(String(field.addon_product.variant_id)).price)+' '+this.copy.perItem;wrapper.append(cost);}
      if(field.helptext){const help=document.createElement('p');help.className='mcs-buy-personal__help';help.textContent=field.helptext;wrapper.append(help);}
      this.fields.append(wrapper);
    }
    values() {
      const values={};
      for(const field of this.schema.fields){
        if(this.isExample(field))continue;
        const inputs=[...this.fields.querySelectorAll('[data-personal-field]')].filter(input=>input.dataset.personalField===field.id);
        if(field.type==='file')values[field.id]=inputs[0]?.dataset.uploaded||'';
        else if(['text','textarea'].includes(field.type))values[field.id]=inputs[0]?.value.trim()||'';
        else values[field.id]=inputs.filter(input=>input.checked).map(input=>field.option_values[Number(input.value)].value);
      }return values;
    }
    selection(values) {
      const properties={},summary=[],addons=[];
      for(const field of this.schema.fields){
        const value=values[field.id];if(!value||Array.isArray(value)&&!value.length)continue;
        const name=field.label_on_cart||field.label,text=Array.isArray(value)?value.join(', '):value;properties[name]=text;summary.push({label:field.label,value:field.type==='file'?this.copy.uploaded:text});
        const selected=field.addon_product?[field.addon_product]:(field.option_values||[]).filter(option=>Array.isArray(value)&&value.includes(option.value)&&option.variant_id);
        for(const option of selected){const addon=this.addonPrices.get(String(option.variant_id));addons.push({...addon,field:name,value:option.value||text,mode:field.advanced_addon==='one_time_charge'?'once':'each'});}
      }return {setId:this.schema.id,values,properties,summary,addons};
    }
    paintPrice() {
      if(!this.schema||this.save.disabled)return;
      const personal=this.selection(this.values());const total=personal.addons.reduce((sum,addon)=>sum+addon.price*(addon.mode==='once'?1:this.draft.quantity),0);
      this.querySelector('[data-personal-price]').textContent=this.owner.money(total);
    }
    async uploadFile(input) {
      const file=input.files?.[0];if(!file)return;const field=this.schema.fields.find(field=>field.id===input.dataset.personalField),note=input.closest('fieldset').querySelector('[data-upload-status]');
      const allowed=field.allowed_extensions||[];if(allowed.length&&!allowed.includes(file.name.split('.').pop().toLowerCase())){note.textContent=this.copy.fileType;input.value='';return;}
      const sequence=this.sequence;this.uploading++;this.save.disabled=true;input.disabled=true;note.textContent=this.copy.upload;
      try {
        const config=window.GPOConfigs;if(new URL(config.appUrl).origin!=='https://option.globo.io')throw Error();
        const body=new FormData();body.append('shop_url',config.shop.url);body.append('option_id',this.schema.id);body.append('element_id',field.id);body.append(field.id+'-1',file);
        const response=await fetch(config.appUrl+'/api/front/uploadFile',{method:'POST',mode:'cors',body});const result=await response.json();
        if(sequence!==this.sequence)return;
        const url=result.uploadedFiles?.[0]?.url;if(!response.ok||!result.success||!url||new URL(url).protocol!=='https:')throw Error();input.dataset.uploaded=url;note.textContent=this.copy.uploaded+' '+file.name;
      }catch{if(sequence===this.sequence)note.textContent=this.copy.failed;}
      finally{if(sequence===this.sequence){this.uploading--;input.disabled=false;input.value='';this.save.disabled=this.uploading>0;this.paintPrice();}}
    }
    validate(values) {
      let previous=null;
      for(const field of this.schema.fields){
        if(this.isExample(field))continue;const value=values[field.id];const has=Array.isArray(value)?value.length>0:!!value;
        if(field.required&&!has)return this.copy.choose+' '+field.label;
        if(['text','textarea','file'].includes(field.type)){previous=field;continue;}
        if(Array.isArray(value)&&Number(field.max)>0&&value.length>Number(field.max))return this.copy.selectionLimit.replace('{max}',field.max);
        if(previous&&/engrav|logo/i.test(field.label)){
          const hasText=!!values[previous.id];if(hasText&&!has)return this.copy.styleRequired;
          if(has&&!hasText)return this.copy.textRequired;
        }
      }
      if(!Object.values(values).some(value=>Array.isArray(value)?value.length:!!value))return this.copy.empty;
      return '';
    }
    commit() {
      if(this.save.disabled||this.uploading||!this.form.reportValidity())return;
      const values=this.values(),problem=this.validate(values);if(problem){this.error.textContent=problem;return;}
      if(!this.draft.key&&this.owner.items.size>=50){this.error.textContent=this.owner.copy.limit;return;}
      const item={...this.draft,key:this.draft.key||crypto.randomUUID(),personalization:this.selection(values)};
      this.owner.items.set(item.key,item);this.owner.persist();this.owner.render();this.owner.status.textContent=this.owner.copy.selected;this.owner.toast(this.owner.copy.selected);this.dialog.close();
    }
    total(item) {return (item.personalization?.addons||[]).reduce((sum,addon)=>sum+addon.price*(addon.mode==='once'?1:item.quantity),0);}
    cartLines(item,token) {
      const key=String(item.key||item.id),personal=item.personalization,group=token+':'+key;
      const properties={...(personal?.properties||{}),_buy_list_request:token,_buy_list_line:key};
      if(personal){properties._has_gpo=personal.setId;if(personal.addons.length)properties._gpo_product_group=group;}
      const parent={id:item.id,quantity:item.quantity,properties};
      const addons=(personal?.addons||[]).map(addon=>({id:addon.id,quantity:addon.mode==='once'?1:item.quantity,properties:{_gpo_parent_product_group:group,_gpo_field_name:addon.field,...(addon.mode==='once'?{_gpo_one_time_charge:1}:{}),_buy_list_request:token,_buy_list_addon_for:key}}));
      return [...addons,parent];
    }
    async verify(items) {
      this.prices.clear();let changed=false;
      for(const item of items){
        const personal=item.personalization;if(!personal)continue;
        const schema=this.schemaFor(item.productId);if(!schema||schema.id!==personal.setId)throw Error(this.copy.unavailable);
        const definitions=this.addonDefinitions(schema);
        for(const addon of personal.addons){
          const definition=definitions.find(({field,value})=>String(value.variant_id)===addon.id&&(field.label_on_cart||field.label)===addon.field);
          if(!definition)throw Error(this.copy.unavailable);
          const latest=await this.loadAddon(definition.value);if(latest.price!==addon.price){addon.price=latest.price;changed=true;}
        }
      }
      if(changed){this.owner.persist();throw Error(this.copy.priceChanged);}
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mcs-corporate-proof"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mcs-client-marquee')) {
    customElements.define('mcs-client-marquee', class extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-ready')) return;
        const button = this.querySelector('button');
        if (!button) return;
        button.hidden = false;
        button.addEventListener('click', () => {
          const paused = this.dataset.paused !== 'true';
          this.dataset.paused = String(paused);
          button.setAttribute('aria-pressed', String(paused));
          button.textContent = paused ? button.dataset.resume : button.dataset.pause;
        });
        this.setAttribute('data-ready', '');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mcs-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mcs-countdown')) {
    customElements.define('mcs-countdown', class extends HTMLElement {
      connectedCallback() {
        this.disconnectedCallback();
        this.abort = new AbortController();
        const iso = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/;
        this.end = iso.test(this.dataset.end) ? new Date(this.dataset.end).getTime() : NaN;
        this.start = this.dataset.start ? (iso.test(this.dataset.start) ? new Date(this.dataset.start).getTime() : NaN) : 0;
        if (!Number.isFinite(this.end) || !Number.isFinite(this.start) || this.start >= this.end) { this.hidden = true; return; }
        this.units = Object.fromEntries(['days', 'hours', 'minutes', 'seconds'].map(unit => [unit, this.querySelector(`[data-unit="${unit}"]`)]));
        this.querySelector('time').textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'en', { dateStyle: 'medium', timeStyle: 'short' }).format(this.end);
        document.addEventListener('visibilitychange', () => this.tick(), { signal: this.abort.signal });
        this.tick();
      }
      tick() {
        clearTimeout(this.timeout);
        const now = new Date().getTime();
        const remaining = Math.max(0, Math.ceil((this.end - now) / 1000));
        this.hidden = now < this.start || remaining === 0;
        if (this.hidden && remaining === 0) return;
        if (!this.hidden) {
          const values = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60 };
          Object.entries(values).forEach(([unit, value]) => { this.units[unit].textContent = String(value).padStart(2, '0'); });
        }
        if (!document.hidden) this.timeout = setTimeout(() => this.tick(), this.hidden ? Math.min(this.start - now, 60000) : 1000);
      }
      disconnectedCallback() { clearTimeout(this.timeout); this.abort?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mcs-local-currency"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.MCSLocalCurrency) return;
  const configNode = document.getElementById('mcs-currency-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  if (config.base !== 'USD' || config.checkout !== 'USD') return;
  const currencyGroups = 'EUR:AD AT AX BE BG BL CY DE EE ES FI FR GF GP GR HR IE IT LT LU LV MC ME MF MQ MT NL PM PT RE SI SK SM TF VA XK YT;USD:AS BQ EC FM GU IO MH MP PA PR PW SV TC TL UM US VG VI;GBP:GB GG GS IM JE;AUD:AU CC CX HM KI NF NR TV;NZD:CK NU NZ PN TK;XCD:AG AI DM GD KN LC MS VC;XOF:BF BJ CI GW ML NE SN TG;XAF:CF CG CM GA GQ TD;XPF:NC PF WF;CHF:CH LI;ILS:IL PS;AED:AE;AFN:AF;ALL:AL;AMD:AM;AOA:AO;ARS:AR;AWG:AW;AZN:AZ;BAM:BA;BBD:BB;BDT:BD;BHD:BH;BIF:BI;BMD:BM;BND:BN;BOB:BO;BRL:BR;BSD:BS;BTN:BT;BWP:BW;BYN:BY;BZD:BZ;CAD:CA;CDF:CD;CLP:CL;CNY:CN;COP:CO;CRC:CR;CUP:CU;CVE:CV;XCG:CW SX;CZK:CZ;DJF:DJ;DKK:DK FO GL;DOP:DO;DZD:DZ;EGP:EG;ERN:ER;ETB:ET;FJD:FJ;FKP:FK;GEL:GE;GHS:GH;GIP:GI;GMD:GM;GNF:GN;GTQ:GT;GYD:GY;HKD:HK;HNL:HN;HTG:HT;HUF:HU;IDR:ID;INR:IN;IQD:IQ;IRR:IR;ISK:IS;JMD:JM;JOD:JO;JPY:JP;KES:KE;KGS:KG;KHR:KH;KMF:KM;KRW:KR;KWD:KW;KYD:KY;KZT:KZ;LAK:LA;LBP:LB;LKR:LK;LRD:LR;LSL:LS;LYD:LY;MAD:MA EH;MDL:MD;MGA:MG;MKD:MK;MMK:MM;MNT:MN;MOP:MO;MRU:MR;MUR:MU;MVR:MV;MWK:MW;MXN:MX;MYR:MY;MZN:MZ;NAD:NA;NGN:NG;NIO:NI;NOK:NO BV SJ;NPR:NP;OMR:OM;PEN:PE;PGK:PG;PHP:PH;PKR:PK;PLN:PL;PYG:PY;QAR:QA;RON:RO;RSD:RS;RUB:RU;RWF:RW;SAR:SA;SBD:SB;SCR:SC;SDG:SD;SEK:SE;SGD:SG;SHP:AC SH TA;SLE:SL;SOS:SO;SRD:SR;SSP:SS;STN:ST;SYP:SY;SZL:SZ;THB:TH;TJS:TJ;TMT:TM;TND:TN;TOP:TO;TRY:TR;TTD:TT;TWD:TW;TZS:TZ;UAH:UA;UGX:UG;UYU:UY;UZS:UZ;VES:VE;VND:VN;VUV:VU;WST:WS;YER:YE;ZAR:ZA;ZMW:ZM;ZWG:ZW';
  const countries = {};
  currencyGroups.split(';').forEach(group => {
    const [currency, codes] = group.split(':');
    codes.split(' ').forEach(country => { countries[country] = currency; });
  });
  const preferenceKey = 'mcs.display-currency.v1';
  const ratesKey = 'mcs.display-rates.v1';
  const geoKey = 'mcs.detected-country.v1';
  const read = (storage, key) => { try { return JSON.parse(window[storage].getItem(key)); } catch { return null; } };
  const write = (storage, key, value) => { try { window[storage].setItem(key, JSON.stringify(value)); } catch {} };
  let rates = { USD: 1 };
  let currency = 'USD';
  let rate = 1;
  let revision = 0;
  let rateRequest;
  let sequence = 0;
  const formatters = new Map();
  const formatter = code => {
    if (!formatters.has(code)) formatters.set(code, new Intl.NumberFormat(config.locale || 'en', { style: 'currency', currency: code, currencyDisplay: 'code' }));
    return formatters.get(code);
  };
  const supported = code => /^[A-Z]{3}$/.test(code || '') && Number.isFinite(rates[code]) && rates[code] > 0;
  const countryCurrency = code => countries[String(code || '').toUpperCase()] || 'USD';
  const format = cents => {
    const amount = Number(cents) / 100;
    if (!Number.isFinite(amount)) return '';
    const usd = formatter('USD').format(amount);
    if (currency === 'USD') return usd;
    return formatter(currency).format(amount * rate);
  };
  const elements = (root, selector) => [...(root.matches?.(selector) ? [root] : []), ...root.querySelectorAll(selector)];
  const bridgeAppPrices = root => {
    const selector = '.product-info__price sale-price, .product-info__price compare-at-price';
    const owners = new Set(elements(root, selector));
    const closest = root.closest?.(selector);
    if (closest) owners.add(closest);
    for (const owner of owners) {
      const source = owner.querySelector(':scope > .money');
      if (!source) continue;
      const match = source.textContent.trim().match(/^(?:USD\s*)?(?:US)?\$\s*([\d,]+(?:\.\d{1,2})?)\s*(?:USD)?$/);
      if (!match) continue;
      const cents = Math.round(Number(match[1].replace(/,/g, '')) * 100);
      if (!Number.isFinite(cents)) continue;
      let display = owner.querySelector('[data-mcs-app-price]');
      if (!display) {
        display = document.createElement('span');
        display.className = 'mcs-local-money';
        display.dataset.mcsAppPrice = '';
        const value = document.createElement('span');
        value.dataset.mcsLocalValue = '';
        value.textContent = formatter('USD').format(cents / 100);
        display.append(value);
        source.after(display);
      }
      source.classList.add('mcs-app-money-source');
      if (display.dataset.mcsUsdCents !== String(cents)) display.dataset.mcsUsdCents = String(cents);
    }
    const addonSelector = '.gpo-app .gpo-label';
    const labels = new Set(elements(root, addonSelector));
    const label = root.closest?.(addonSelector);
    if (label) labels.add(label);
    for (const owner of labels) {
      const source = owner.querySelector('.addOn');
      const match = source?.textContent.trim().match(/^\(\+\s*(?:USD\s*)?(?:US)?\$\s*([\d,]+(?:\.\d{1,2})?)\s*(?:USD)?\)$/);
      if (!match) continue;
      const cents = Math.round(Number(match[1].replace(/,/g, '')) * 100);
      if (!Number.isFinite(cents)) continue;
      let display = owner.querySelector('[data-mcs-app-addon]');
      if (!display) {
        display = document.createElement('span');
        display.className = 'mcs-local-money';
        display.dataset.mcsAppAddon = '';
        const value = document.createElement('span');
        value.dataset.mcsLocalValue = '';
        display.append(value);
        source.after(display);
      }
      source.classList.add('mcs-app-money-source');
      if (display.dataset.mcsUsdCents !== String(cents)) display.dataset.mcsUsdCents = String(cents);
    }
  };
  const render = root => {
    bridgeAppPrices(root);
    elements(root, '[data-mcs-usd-cents]').forEach(el => {
      const cents = Number(el.dataset.mcsUsdCents);
      if (!Number.isFinite(cents) || el.dataset.mcsCurrencyStamp === revision + ':' + cents) return;
      const value = el.querySelector('[data-mcs-local-value]');
      if (!value) return;
      const valueText = currency === 'USD' && el.closest('.mcs-product-shipping-threshold') && cents === 10000 ? '$100' : format(cents);
      value.textContent = el.hasAttribute('data-mcs-app-addon') ? '(+ ' + valueText + ')' : valueText;
      el.dataset.mcsCurrencyStamp = revision + ':' + cents;
    });
    elements(root, '[data-mcs-option-usd]').forEach(el => {
      const label = el.dataset.mcsOptionTitle + ' — ' + format(el.dataset.mcsOptionUsd);
      if (el.textContent !== label) el.textContent = label;
    });
    elements(root, '[data-mcs-current-currency]').forEach(el => { if (el.textContent !== currency) el.textContent = currency; });
    elements(root, '[data-mcs-country-currency]').forEach(el => {
      const code = countryCurrency(el.dataset.mcsCountryCurrency);
      const label = supported(code) ? code : 'USD';
      if (el.textContent !== label) el.textContent = label;
    });
    elements(root, '[data-mcs-currency-select]').forEach(select => {
      if (!select.dataset.ready) {
        const codes = [...new Set(['USD', ...Object.values(countries)])].filter(supported).sort();
        select.replaceChildren(...codes.map(code => new Option(code, code)));
        select.dataset.ready = 'true';
      }
      select.value = currency;
    });
  };
  async function loadRates() {
    if (rateRequest) return rateRequest;
    rateRequest = (async () => {
      const cached = read('localStorage', ratesKey);
      if (cached && Date.now() >= cached.saved && Date.now() - cached.saved < 43200000 && cached.rates?.USD === 1) {
        rates = cached.rates;
        return;
      }
      const response = await fetch('https://cdn.shopify.com/s/javascripts/currencies.js', { signal: AbortSignal.timeout(5000), credentials: 'omit' });
      if (!response.ok) throw new Error('Rates unavailable');
      const text = await response.text();
      const body = text.match(/rates\s*:\s*\{([^}]+)\}/)?.[1];
      if (!body) throw new Error('Invalid rates');
      const next = { USD: 1 };
      for (const entry of body.split(',')) {
        const match = entry.trim().match(/^([A-Z]{3})\s*:\s*([\d.eE+-]+)$/);
        if (!match) continue;
        const value = Number(match[2]);
        if (Number.isFinite(value) && value > 0) next[match[1]] = 1 / value;
      }
      if (!next.EUR || !next.GBP || !next.AUD || next.USD !== 1) throw new Error('Incomplete rates');
      rates = next;
      write('localStorage', ratesKey, { saved: Date.now(), rates });
    })().catch(() => { rates = { USD: 1 }; });
    return rateRequest;
  }
  async function setCurrency(code, remember = false) {
    const current = ++sequence;
    if (remember) write('localStorage', preferenceKey, { code, saved: Date.now() });
    await loadRates();
    if (current !== sequence) return;
    currency = supported(code) ? code : 'USD';
    rate = rates[currency];
    revision += 1;
    document.querySelectorAll('[data-mcs-currency-select]').forEach(el => { delete el.dataset.ready; });
    render(document);
    document.querySelectorAll('free-shipping-bar').forEach(el => el._updateMessage?.());
    document.dispatchEvent(new CustomEvent('mcs:currency:change', { detail: { currency, rate } }));
  }
  window.MCSLocalCurrency = { format, setCurrency, countryCurrency, get currency() { return currency; }, get rate() { return rate; } };
  document.addEventListener('change', event => {
    if (event.target.matches('[data-mcs-currency-select]')) setCurrency(event.target.value, true);
  });
  document.addEventListener('click', event => {
    const button = event.target.closest?.('button[name="country_code"]');
    if (button) write('localStorage', preferenceKey, { code: countryCurrency(button.value), saved: Date.now() });
  }, true);
  document.addEventListener('submit', event => {
    const input = event.target.querySelector?.('select[name="country_code"]');
    if (input) write('localStorage', preferenceKey, { code: countryCurrency(input.value), saved: Date.now() });
  }, true);
  window.addEventListener('storage', event => {
    if (event.key === preferenceKey) setCurrency(read('localStorage', preferenceKey)?.code || countryCurrency(config.country));
  });
  const roots = new Set();
  let scheduled = false;
  const observer = new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'attributes') roots.add(record.target);
      const ownerSelector = '.product-info__price sale-price, .product-info__price compare-at-price, .gpo-app .gpo-label';
      const owner = record.target.nodeType === 1 ? record.target.closest(ownerSelector) : record.target.parentElement?.closest(ownerSelector);
      if (owner) roots.add(owner);
      for (const node of record.addedNodes) if (node.nodeType === 1) roots.add(node);
    }
    if (scheduled || roots.size === 0) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      const pending = [...roots]; roots.clear();
      pending.filter(root => root.isConnected).forEach(render);
    });
  });
  observer.observe(document.body, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['data-mcs-usd-cents'] });
  async function start() {
    const initialSequence = sequence;
    const preference = read('localStorage', preferenceKey);
    if (preference?.code && Date.now() - preference.saved < 31536000000) return setCurrency(preference.code);
    const detected = read('sessionStorage', geoKey);
    if (detected?.country) return setCurrency(countryCurrency(detected.country));
    let country = config.country;
    try {
      const url = new URL(config.root + 'browsing_context_suggestions.json', location.origin);
      url.searchParams.set('country[enabled]', 'true');
      const response = await fetch(url, { signal: AbortSignal.timeout(3500) });
      if (response.ok) {
        const data = await response.json();
        country = data.detected_values?.country?.handle || country;
        write('sessionStorage', geoKey, { country });
      }
    } catch {}
    if (sequence !== initialSequence) return;
    return setCurrency(countryCurrency(country));
  }
  start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mcs-personalization"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mcs-personalization')) {
  customElements.define('mcs-personalization', class extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.panel = this.querySelector('[data-personalization-content]');
      this.label = this.querySelector('[data-personalization-label]');
      this.price = this.querySelector('[data-personalization-price]');
      if (!this.details || !this.panel) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('input', () => this.sync(), options);
      this.addEventListener('change', () => this.sync(), options);
      this.panel.addEventListener('invalid', () => { this.details.open = true; }, { ...options, capture: true });
      this.observer = new MutationObserver(() => this.schedule());
      this.observer.observe(this.panel, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['required', 'aria-required', 'data-mcs-usd-cents'] });
      this.info = this.closest('.mcs-product-info');
      const preparePurchase = event => {
        const control = event.target.closest?.('button, input, form');
        if (!control || !this.info?.contains(control)) return;
        if (event.type !== 'submit' && !control.matches('[type="submit"], [name="add"]')) return;
        this.sync();
        if (this.hasEnteredValue) this.details.open = true;
      };
      window.addEventListener('click', preparePurchase, { ...options, capture: true });
      window.addEventListener('submit', preparePurchase, { ...options, capture: true });
      if (this.info) {
        this.previewObserver = new MutationObserver(records => {
          if (records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches('.engraving-popup-container') || node.querySelector('.engraving-popup-container'))))) this.schedule();
        });
        this.previewObserver.observe(this.info, { childList: true, subtree: true });
      }
      this.sync();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.previewObserver?.disconnect();
      cancelAnimationFrame(this.frame);
    }
    schedule() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => { this.frame = null; if (this.isConnected) this.sync(); });
    }
    sync() {
      const app = this.panel.querySelector('.gpo-app');
      if (!app) return;
      const elements = Array.from(app.querySelectorAll('.gpo-element')).filter(element => element.querySelector('input:not([type="hidden"]), textarea, select'));
      if (!elements.length) return;
      elements.forEach(element => {
        const label = element.querySelector('.label-content')?.textContent || '';
        const choices = element.querySelector('.gpo-image-dropdown, .gpo-swatches.image-swatches');
        element.classList.toggle('mcs-engraving-cards', Boolean(choices) && /engrav|personali[sz]|logo/i.test(label));
      });
      this.syncPrices(app);
      const supported = elements.every(element => {
        const label = element.querySelector('.label-content')?.textContent || '';
        return /engrav|personali[sz]/i.test(label) && !element.querySelector('[required], [aria-required="true"], .gpo-label.required');
      });
      if (!supported) {
        this.details.open = true;
        this.summary.hidden = true;
        this.removeAttribute('data-ready');
        return;
      }
      const engraving = elements.filter(element => !/example|preview|styles/i.test(element.querySelector('.label-content')?.textContent || ''));
      const hasValue = engraving.some(element => Array.from(element.querySelectorAll('input:not([type="hidden"]), textarea, select')).some(input => ['radio', 'checkbox'].includes(input.type) ? input.checked : Boolean(input.value.trim())));
      this.hasEnteredValue = hasValue;
      if (!this.hasAttribute('data-ready')) {
        this.details.open = hasValue || this.hasAttribute('data-editor');
        this.summary.hidden = false;
        this.setAttribute('data-ready', '');
      }
      const nextLabel = hasValue ? this.dataset.editLabel : this.dataset.addLabel;
      if (this.label.textContent !== nextLabel) this.label.textContent = nextLabel;
      const addonLabel = engraving[0]?.querySelector('.gpo-label');
      const addon = addonLabel?.querySelector('[data-mcs-local-value]') || addonLabel?.querySelector('.addOn');
      const amount = addon?.textContent.trim() || '';
      if (this.price.textContent !== amount) this.price.textContent = amount;
      if (Array.from(app.querySelectorAll('.messages')).some(message => message.textContent.trim())) this.details.open = true;
      app.querySelectorAll('img').forEach(image => {
        if (!image.hasAttribute('loading')) image.loading = 'lazy';
        if (image.decoding !== 'async') image.decoding = 'async';
      });
      this.movePreview();
    }
    syncPrices(app) {
      if (!window.MCSLocalCurrency) return;
      app.querySelectorAll('.mcs-engraving-cards .gpo-ov-item .addOn, .gpo-total-text > .money').forEach(source => {
        const match = source.textContent.trim().match(/^(?:\(\+\s*)?(?:USD\s*)?(?:US)?\$\s*([\d,]+(?:\.\d{1,2})?)\s*(?:USD)?\)?$/);
        if (!match) return;
        const cents = Math.round(Number(match[1].replace(/,/g, '')) * 100);
        if (!Number.isFinite(cents)) return;
        let display = source.nextElementSibling;
        if (!display?.hasAttribute('data-mcs-card-price')) {
          display = document.createElement('span');
          display.className = 'mcs-local-money';
          display.dataset.mcsCardPrice = '';
          if (source.classList.contains('addOn')) display.dataset.mcsAppAddon = '';
          const value = document.createElement('span');
          value.dataset.mcsLocalValue = '';
          display.append(value);
          source.after(display);
        }
        source.classList.add('mcs-app-money-source');
        if (display.dataset.mcsUsdCents !== String(cents)) display.dataset.mcsUsdCents = String(cents);
      });
    }
    movePreview() {
      if (!this.info) return;
      this.info.querySelectorAll('.engraving-popup-container').forEach(preview => {
        if (this.panel.contains(preview)) return;
        const block = preview.closest('.product-info__block-item');
        const duplicate = this.panel.querySelector('.engraving-popup-container');
        if (duplicate) duplicate.replaceWith(preview);
        else this.panel.append(preview);
        if (block) {
          const remainder = block.cloneNode(true);
          remainder.querySelectorAll('style, script').forEach(node => node.remove());
          if (!remainder.textContent.trim() && !remainder.querySelector('input, select, textarea, img, button, a')) block.classList.add('mcs-personalization-empty-block');
        }
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mcs-policy-tooltip"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mcs-policy-tip')) {
  customElements.define('mcs-policy-tip', class extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('.mcs-policy-tip__trigger');
      this.panel = this.querySelector('.mcs-policy-tip__panel');
      if (!this.trigger || !this.panel) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.trigger.addEventListener('pointerdown', () => { this.pointerDown = true; }, options);
      this.trigger.addEventListener('focus', () => {
        if (!this.pointerDown && !this.restoringFocus) this.open();
      }, options);
      this.trigger.addEventListener('click', event => {
        event.preventDefault();
        this.pointerDown = false;
        if (this.isOpen && this.pinned) this.close();
        else { this.pinned = true; this.open(); }
      }, options);
      this.querySelector('.mcs-policy-tip__close').addEventListener('click', event => {
        event.preventDefault(); this.close(true);
      }, options);
      [this.trigger, this.panel].forEach(element => {
        element.addEventListener('pointerenter', event => {
          clearTimeout(this.closeTimer);
          if (event.pointerType === 'mouse') this.open();
        }, options);
        element.addEventListener('pointerleave', () => {
          if (!this.pinned) this.closeTimer = setTimeout(() => {
            if (!this.contains(document.activeElement)) this.close();
          }, 180);
        }, options);
      });
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget)) this.close();
      }, options);
      this.panel.addEventListener('toggle', event => {
        if (event.newState === 'closed') this.reset();
      }, options);
      document.addEventListener('pointerdown', event => {
        if (this.isOpen && !this.contains(event.target)) this.close();
      }, options);
      window.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.isOpen) {
          event.preventDefault(); event.stopPropagation(); this.close(this.panel.contains(document.activeElement));
        }
      }, { ...options, capture: true });
      window.addEventListener('resize', () => this.position(), options);
      window.addEventListener('scroll', () => this.position(), { ...options, capture: true, passive: true });
    }
    disconnectedCallback() {
      this.close(); this.controller?.abort(); clearTimeout(this.closeTimer);
    }
    get isOpen() { return this.panel?.hasAttribute('data-open'); }
    open() {
      clearTimeout(this.closeTimer);
      if (!this.isConnected) return;
      if (!this.isOpen) {
        this.panel.setAttribute('data-open', '');
        this.panel.showPopover?.();
        this.trigger.setAttribute('aria-expanded', 'true');
      }
      this.position();
    }
    position() {
      if (!this.isOpen) return;
      const anchor = this.trigger.getBoundingClientRect();
      if (!anchor.width || !anchor.height) { this.close(); return; }
      const box = this.panel.getBoundingClientRect();
      const left = Math.max(12, Math.min(anchor.right - box.width, innerWidth - box.width - 12));
      const below = anchor.bottom + 8;
      const top = below + box.height <= innerHeight - 12 ? below : Math.max(12, anchor.top - box.height - 8);
      this.panel.style.left = `${left}px`;
      this.panel.style.top = `${top}px`;
    }
    reset() {
      this.panel?.removeAttribute('data-open');
      this.trigger?.setAttribute('aria-expanded', 'false');
      this.pinned = false; this.pointerDown = false;
    }
    close(restoreFocus = false) {
      clearTimeout(this.closeTimer);
      if (this.panel?.hidePopover && this.panel.matches(':popover-open')) this.panel.hidePopover();
      this.reset();
      if (restoreFocus && this.trigger?.isConnected) {
        this.restoringFocus = true; this.trigger.focus(); this.restoringFocus = false;
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mcs-product-purchase-style"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialized = new WeakSet();
  function init(root) {
    root.querySelectorAll('.mcs-product-info [data-mcs-delivery-select]').forEach(group => {
      if (initialized.has(group)) return;
      const labels = Array.from(group.querySelectorAll('label:has(input[type="radio"]) > span:first-of-type'));
      if (!labels.length) return;
      initialized.add(group);
      let frame;
      const fit = () => {
        frame = null;
        if (!group.isConnected) { observer?.disconnect(); return; }
        let size = 16;
        for (const label of labels) {
          const style = getComputedStyle(label);
          const range = document.createRange();
          range.selectNodeContents(label);
          const width = range.getBoundingClientRect().width;
          const available = label.clientWidth - 1;
          if (width <= 0 || available <= 0) return;
          const spacing = (parseFloat(style.letterSpacing) || 0) * Array.from(label.textContent.trim()).length;
          size = Math.min(size, parseFloat(style.fontSize) * Math.max(1, available - spacing) / Math.max(1, width - spacing));
        }
        const value = `${Math.floor(size * 10) / 10}px`;
        if (group.style.getPropertyValue('--mcs-shipping-label-size') !== value) group.style.setProperty('--mcs-shipping-label-size', value);
      };
      const schedule = () => { if (!frame) frame = requestAnimationFrame(fit); };
      const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;
      labels.forEach(label => observer?.observe(label));
      document.fonts?.ready.then(schedule);
      schedule();
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mcs-product-tabs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mcs-product-tabs')) {
    customElements.define('mcs-product-tabs', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.items = [...this.querySelectorAll(':scope > details')];
        this.buttons = [...this.querySelectorAll('[role="tab"]')];
        this.nav = this.querySelector('.mcs-tabs__nav');
        this.media = matchMedia('(min-width: 750px)');
        this.selected = 0;
        this.buttons.forEach((button, index) => {
          button.addEventListener('click', () => this.select(index), options);
          button.addEventListener('keydown', event => {
            const rtl = getComputedStyle(this).direction === 'rtl';
            let next = index;
            if (event.key === 'ArrowRight') next += rtl ? -1 : 1;
            else if (event.key === 'ArrowLeft') next += rtl ? 1 : -1;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = this.buttons.length - 1;
            else return;
            event.preventDefault();
            next = (next + this.buttons.length) % this.buttons.length;
            this.select(next);
            this.buttons[next].focus();
          }, options);
        });
        this.items.forEach((item, index) => item.addEventListener('toggle', () => {
          if (!this.media.matches && item.open) {
            this.selected = index;
            if (this.dataset.multiple !== 'true') this.items.forEach(other => { if (other !== item) other.open = false; });
          }
        }, options));
        this.media.addEventListener('change', () => this.layout(), options);
        this.layout();
      }
      select(index) {
        this.selected = index;
        this.items.forEach((item, position) => {
          item.open = position === index;
          this.buttons[position].setAttribute('aria-selected', String(position === index));
          this.buttons[position].tabIndex = position === index ? 0 : -1;
        });
      }
      layout() {
        this.nav.hidden = !this.media.matches;
        this.items.forEach((item, index) => {
          item.querySelector('summary').hidden = this.media.matches;
          const panel = item.querySelector('.mcs-tabs__panel');
          if (this.media.matches) {
            panel.setAttribute('role', 'tabpanel');
            panel.setAttribute('aria-labelledby', this.buttons[index].id);
            panel.tabIndex = 0;
          } else {
            panel.removeAttribute('role');
            panel.removeAttribute('aria-labelledby');
            panel.removeAttribute('tabindex');
          }
        });
        this.select(this.selected);
      }
      disconnectedCallback() { this.abort?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mcs-shopping-tools"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('mcs-shopping-tools')) return;
  const managedTag = /^mcs-(size|material|storage|personalization)-/;
  let memorySelection = [];
  let memoryKey = '';
  const choices = () => [...document.querySelectorAll('mcs-compare-choice')];
  const safePath = (value) => {
    try { const url = new URL(value, location.origin); return url.origin === location.origin ? url.pathname + url.search : '#'; }
    catch { return '#'; }
  };
  const safeImage = (value) => {
    try { const url = new URL(value, location.origin); return url.protocol === 'https:' && (url.origin === location.origin || url.hostname === 'cdn.shopify.com') ? url.href : ''; }
    catch { return ''; }
  };
  class ShoppingTools extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.labels = this.querySelector('[data-shopping-labels]').dataset;
      this.comparisonEnabled = this.dataset.comparisonEnabled === 'true';
      this.dialog = this.querySelector('dialog');
      this.selection = [];
      if (memoryKey === this.dataset.storageKey) this.selection = memorySelection;
      try {
        const saved = JSON.parse(sessionStorage.getItem(this.dataset.storageKey) || 'null');
        if (saved && Date.now() - saved.time < 7200000 && Array.isArray(saved.items)) {
          this.selection = saved.items.filter(p => p && /^\d+$/.test(p.id) && typeof p.title === 'string' && p.facts && typeof p.facts === 'object').slice(0, 3);
        }
      } catch { /* Browsing still works when storage is unavailable. */ }
      this.selection = [...new Map(this.selection.map(p => [p.id, p])).values()];
      this.querySelectorAll('[data-feature-filters] select, [data-feature-filters] button').forEach(control => { control.disabled = false; });
      this.querySelector('[data-feature-filters]').addEventListener('submit', e => {
        e.preventDefault();
        this.navigateFeatures([...new FormData(e.currentTarget).values()].filter(Boolean));
      }, { signal });
      this.querySelector('[data-clear-features]').addEventListener('click', e => {
        e.preventDefault(); this.navigateFeatures([]);
      }, { signal });
      this.addEventListener('click', e => {
        if (e.target.closest('[data-open-compare]')) {
          if (this.selection.length < 2) { this.announce(this.labels.chooseTwo); return; }
          this.opener = e.target.closest('button');
          this.renderTable();
          this.dialog.showModal();
          document.documentElement.classList.add('mcs-comparison-open');
        }
        if (e.target.closest('[data-close-compare]')) this.dialog.close();
        if (e.target.closest('[data-clear-compare]')) { this.selection = []; this.save(); this.refresh(); }
        const remove = e.target.closest('[data-remove-product]');
        if (remove) {
          this.selection = this.selection.filter(p => p.id !== remove.dataset.removeProduct);
          this.save(); this.refresh();
          if (this.selection.length < 2) this.dialog.close();
          else { this.renderTable(); this.dialog.querySelector('[data-close-compare]').focus(); }
        }
      }, { signal });
      this.dialog.addEventListener('click', e => {
        if (e.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom) this.dialog.close();
      }, { signal });
      this.dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('mcs-comparison-open');
        if (this.opener?.isConnected) this.opener.focus();
      }, { signal });
      document.addEventListener('mcs:compare-change', e => this.toggle(e.detail.choice), { signal });
      this.refresh();
      const count = document.querySelector('[data-mcs-collection-count]');
      if (count) count.textContent = this.dataset.count;
    }
    disconnectedCallback() {
      this.controller?.abort();
      if (this.dialog?.open) { this.dialog.close(); document.documentElement.classList.remove('mcs-comparison-open'); }
    }
    navigateFeatures(selected) {
      let active = [];
      try { active = JSON.parse(this.dataset.tags || '[]') || []; } catch { /* Empty tags. */ }
      const tags = [...active.filter(t => !managedTag.test(t)), ...selected];
      const url = new URL(this.dataset.baseUrl, location.origin);
      url.pathname += tags.length ? '/' + tags.map(encodeURIComponent).join('+') : '';
      url.search = location.search;
      url.searchParams.delete('page');
      url.searchParams.delete('section_id');
      location.assign(url.href);
    }
    capture(choice) {
      let facts;
      try { facts = JSON.parse(choice.dataset.facts); } catch { return null; }
      const price = choice.closest('product-card')?.querySelector('sale-price')?.cloneNode(true);
      price?.querySelectorAll('.sr-only').forEach(node => node.remove());
      return { id: choice.dataset.id, title: choice.dataset.title, url: safePath(choice.dataset.url), image: safeImage(choice.dataset.image), facts, price: price?.textContent.trim().replace(/\s+/g, ' ') || '' };
    }
    toggle(choice) {
      const current = this.selection.find(p => p.id === choice.dataset.id);
      if (current) this.selection = this.selection.filter(p => p.id !== current.id);
      else if (this.selection.length >= 3) { this.announce(this.labels.limit); this.refresh(); return; }
      else { const product = this.capture(choice); if (product) this.selection.push(product); }
      this.save(); this.refresh();
      this.announce(`${this.labels.selected}: ${this.selection.length}/3`);
    }
    save() {
      memoryKey = this.dataset.storageKey;
      memorySelection = this.selection;
      try { sessionStorage.setItem(this.dataset.storageKey, JSON.stringify({time: Date.now(), items: this.selection})); } catch { /* Session memory remains available. */ }
    }
    announce(message) { this.querySelector('[data-shopping-status]').textContent = message; }
    refresh() {
      choices().forEach(choice => {
        choice.hidden = false;
        choice.querySelector('input').disabled = false;
        choice.querySelector('input').checked = this.selection.some(p => p.id === choice.dataset.id);
      });
      this.querySelectorAll('[data-selected-count]').forEach(n => { n.textContent = this.selection.length; });
      this.querySelector('[data-compare-tray]').hidden = !this.comparisonEnabled || this.selection.length === 0;
      this.querySelectorAll('[data-open-compare]').forEach(button => { button.hidden = !this.comparisonEnabled; button.disabled = this.selection.length < 2; });
    }
    renderTable() {
      const head = this.querySelector('[data-compare-head]');
      [...head.children].slice(1).forEach(n => n.remove());
      this.querySelectorAll('[data-compare-row]').forEach(row => [...row.children].slice(1).forEach(n => n.remove()));
      this.querySelector('table').style.minWidth = `${140 + this.selection.length * 210}px`;
      this.selection.forEach(product => {
        const visible = choices().find(choice => choice.dataset.id === product.id);
        if (visible) Object.assign(product, this.capture(visible));
        const th = document.createElement('th'); th.scope = 'col';
        const source = safeImage(product.image);
        if (source) { const img = document.createElement('img'); img.src = source; img.alt = ''; img.width = 120; img.height = 120; img.loading = 'lazy'; th.append(img); }
        const title = document.createElement('a'); title.href = safePath(product.url); title.className = 'mcs-shopping__product-title'; title.textContent = product.title; th.append(title);
        const actions = document.createElement('div'); actions.className = 'mcs-shopping__product-actions';
        const link = document.createElement('a'); link.href = safePath(product.url); link.textContent = this.labels.view; actions.append(link);
        const remove = document.createElement('button'); remove.type = 'button'; remove.className = 'mcs-shopping__clear'; remove.dataset.removeProduct = product.id; remove.textContent = this.labels.remove; remove.setAttribute('aria-label', `${this.labels.remove}: ${product.title}`); actions.append(remove);
        th.append(actions); head.append(th);
        this.querySelectorAll('[data-compare-row]').forEach(row => {
          const cell = document.createElement('td'); const key = row.dataset.compareRow;
          const value = key === 'price' ? product.price : product.facts[key];
          cell.textContent = typeof value === 'string' && value ? value : this.labels.unknown;
          if (key === 'price' && !value) { const link = document.createElement('a'); link.href = safePath(product.url); link.textContent = this.labels.currentPrice; cell.replaceChildren(link); }
          row.append(cell);
        });
      });
    }
  }
  class CompareChoice extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const shopping = document.querySelector('mcs-shopping-tools');
      if (!shopping) return;
      this.hidden = false;
      this.querySelector('input').disabled = false;
      this.querySelector('input').checked = shopping.selection?.some(p => p.id === this.dataset.id) || false;
      this.addEventListener('change', () => this.dispatchEvent(new CustomEvent('mcs:compare-change', { bubbles: true, detail: { choice: this } })), { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  }
  customElements.define('mcs-shopping-tools', ShoppingTools);
  customElements.define('mcs-compare-choice', CompareChoice);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mcs-speed-layer"] && !Shopify.designMode) return;
  try {
    (() => {
  const loadImage = image => {
    if (!image?.hasAttribute('data-mcs-gallery-src')) return;
    const source = image.getAttribute('data-mcs-gallery-src');
    const sources = image.getAttribute('data-mcs-gallery-srcset');
    image.loading = 'eager';
    if (sources) image.srcset = sources;
    image.src = source;
    image.removeAttribute('data-mcs-gallery-src');
    image.removeAttribute('data-mcs-gallery-srcset');
  };

  const galleries = new WeakSet();
  const setupGalleries = (root = document) => {
    root.querySelectorAll('media-carousel').forEach(carousel => {
      if (galleries.has(carousel)) return;
      galleries.add(carousel);
      const images = carousel.querySelectorAll('img[data-mcs-gallery-src]');
      if (!('IntersectionObserver' in window)) {
        images.forEach(loadImage);
        return;
      }
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !entry.target.closest('[hidden]')) {
            loadImage(entry.target);
            observer.unobserve(entry.target);
          }
        });
      }, {rootMargin: '200px 0px'});
      images.forEach(image => observer.observe(image));
      const selected = event => {
        event.detail?.slide?.querySelectorAll('img[data-mcs-gallery-src]').forEach(loadImage);
      };
      carousel.addEventListener('carousel:select', selected);
      carousel.addEventListener('carousel:change', selected);
    });
  };

  document.addEventListener('click', event => {
    const button = event.target.closest?.('.product-gallery__thumbnail, product-gallery page-dots button');
    if (!button) return;
    const gallery = button.closest('product-gallery');
    const buttons = Array.from(button.parentElement.children);
    const index = buttons.indexOf(button);
    gallery?.querySelectorAll('media-carousel').forEach(carousel => {
      carousel.children[index]?.querySelectorAll('img[data-mcs-gallery-src]').forEach(loadImage);
    });
  }, true);

  document.addEventListener('variant:change', event => {
    const id = event.detail?.variant?.featured_media?.id;
    if (id) document.querySelectorAll(`[data-media-id="${id}"] img[data-mcs-gallery-src]`).forEach(loadImage);
  }, true);
  document.addEventListener('shopify:section:load', event => setupGalleries(event.target));
  document.addEventListener('product:rerender', () => requestAnimationFrame(() => setupGalleries()));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setupGalleries(), {once: true});
  else setupGalleries();

  class LazyApp extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-loaded')) return;
      if (!('IntersectionObserver' in window)) return this.activate();
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) this.activate();
      }, {rootMargin: '300px 0px'});
      this.observer.observe(this);
    }
    disconnectedCallback() { this.observer?.disconnect(); }
    async activate() {
      if (this.hasAttribute('data-loaded')) return;
      const template = this.querySelector('template[data-mcs-app]');
      if (!template) return;
      this.setAttribute('data-loaded', '');
      this.observer?.disconnect();
      const fragment = template.content.cloneNode(true);
      const scripts = Array.from(fragment.querySelectorAll('script'));
      scripts.forEach(script => script.remove());
      this.appendChild(fragment);
      template.remove();
      for (const original of scripts) {
        if (original.src && Array.from(document.scripts).some(script => script.src === original.src)) continue;
        const script = document.createElement('script');
        Array.from(original.attributes).forEach(attribute => script.setAttribute(attribute.name, attribute.value));
        script.textContent = original.textContent;
        if (script.src) {
          script.async = false;
          await new Promise(resolve => {
            script.onload = script.onerror = resolve;
            this.appendChild(script);
          });
        } else this.appendChild(script);
      }
    }
  }

  class EmailLoader extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      window.mc_embedded = true;
      const start = () => {
        if (this.loaded) return;
        this.loaded = true;
        clearTimeout(this.timer);
        ['pointerdown', 'keydown'].forEach(type => window.removeEventListener(type, engage));
        if (Array.from(document.scripts).some(script => script.src === this.dataset.scriptUrl)) return;
        const script = document.createElement('script');
        script.src = this.dataset.scriptUrl;
        script.async = true;
        script.fetchPriority = 'low';
        document.head.appendChild(script);
      };
      const engage = () => {
        if (this.engaged) return;
        this.engaged = true;
        this.engagementTimer = setTimeout(start, 600);
      };
      if (this.dataset.productPage !== 'true') return start();
      ['pointerdown', 'keydown'].forEach(type => window.addEventListener(type, engage, {passive: true}));
      const afterLoad = () => { if (!this.loaded) this.timer = setTimeout(start, 8000); };
      if (document.readyState === 'complete') afterLoad();
      else window.addEventListener('load', afterLoad, {once: true});
    }
  }
  if (!customElements.get('mcs-lazy-app')) customElements.define('mcs-lazy-app', LazyApp);
  if (!customElements.get('mcs-email-loader')) customElements.define('mcs-email-loader', EmailLoader);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mcs-upsells"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mcs-upsells')) {
    customElements.define('mcs-upsells', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.addEventListener('submit', event => this.add(event), options);
        this.addEventListener('change', event => this.changeVariant(event), options);
        this.addEventListener('click', event => {
          if (event.target.closest('[data-offer-more]')) {
            this.expanded = !this.expanded;
            this.updateVisible();
          }
          if (event.target.closest('[data-offer-retry]')) this.load();
        }, options);
        document.addEventListener('cart:change', event => {
          if (event.detail?.cart?.items) this.filterCart(event.detail.cart);
        }, options);
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            this.observer.disconnect();
            this.load();
          }
        }, { rootMargin: '200px' });
        this.observer.observe(this);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }
      async load() {
        if (this.loading || this.loaded) return;
        this.loading = true;
        this.querySelector('[data-offer-retry]').hidden = true;
        this.querySelector('[data-offer-status]').textContent = '';
        try {
          const url = new URL(this.dataset.url, location.origin);
          url.searchParams.set('section_id', 'mcs-upsell-results');
          const preview = new URL(location.href).searchParams.get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id', preview);
          const response = await fetch(url, { signal: this.controller.signal });
          if (!response.ok) throw new Error();
          const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
          const content = parsed.querySelector('[data-mcs-upsell-results]');
          if (!this.isConnected) return;
          this.loaded = true;
          if (!content?.querySelector('[data-product-id]')) { this.hidden = true; return; }
          this.querySelector('[data-offer-content]').replaceChildren(content);
          if (this.cart) this.filterCart(this.cart);
          else this.updateVisible();
        } catch (error) {
          if (error.name !== 'AbortError' && this.isConnected) {
            this.querySelector('[data-offer-content]').replaceChildren();
            this.querySelector('[data-offer-status]').textContent = this.dataset.loadError;
            this.querySelector('[data-offer-retry]').hidden = false;
          }
        } finally { this.loading = false; }
      }
      filterCart(cart) {
        this.cart = cart;
        const ids = new Set(cart.items.map(item => String(item.product_id)));
        this.querySelectorAll('[data-product-id]').forEach(card => {
          card.dataset.inCart = String(ids.has(card.dataset.productId));
        });
        this.updateVisible();
      }
      updateVisible() {
        const cards = Array.from(this.querySelectorAll('[data-product-id]'));
        const eligible = cards.filter(card => card.dataset.inCart !== 'true');
        const limit = Number(this.dataset.limit) || 3;
        cards.forEach(card => { card.hidden = !eligible.includes(card) || (!this.expanded && eligible.indexOf(card) >= limit); });
        const more = this.querySelector('[data-offer-more]');
        if (more) {
          more.hidden = eligible.length <= limit;
          more.textContent = this.expanded ? this.dataset.less : this.dataset.more;
          more.setAttribute('aria-expanded', String(Boolean(this.expanded)));
        }
        if (this.loaded) this.hidden = eligible.length === 0;
      }
      changeVariant(event) {
        const select = event.target.closest('[data-offer-variant]');
        if (!select) return;
        const option = select.selectedOptions[0];
        const card = select.closest('[data-product-id]');
        const offerAmount = card.querySelector('[data-offer-price] [data-mcs-usd-cents]');
        if (offerAmount) offerAmount.dataset.mcsUsdCents = option.dataset.offerCents;
        else card.querySelector('[data-offer-price]').textContent = option.dataset.offerPrice;
        const regular = card.querySelector('[data-regular-price]');
        if (regular) {
          const amount = regular.querySelector('[data-mcs-usd-cents]');
          if (amount) amount.dataset.mcsUsdCents = option.dataset.regularCents;
          else regular.textContent = option.dataset.regularPrice;
        }
        const img = card.querySelector('img');
        if (img && option.dataset.image) { img.removeAttribute('srcset'); img.src = option.dataset.image; }
        card.querySelectorAll('a').forEach(link => {
          const url = new URL(link.href); url.searchParams.set('variant', option.value); link.href = url;
        });
      }
      async add(event) {
        const form = event.target.closest('[data-offer-form]');
        if (!form) return;
        event.preventDefault();
        if (this.adding || !form.reportValidity()) return;
        this.adding = true;
        const button = form.querySelector('[type="submit"]');
        const originalLabel = button.textContent;
        const status = this.querySelector('[data-offer-status]');
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = this.dataset.adding;
        status.textContent = '';
        let added = false;
        try {
          const sections = ['variant-added'];
          document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));
          const data = new FormData(form);
          data.set('sections', [...new Set(sections)].slice(0, 5).join(','));
          data.set('sections_url', location.pathname);
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(root + 'cart/add.js', { method: 'POST', body: data, headers: { 'X-Requested-With': 'XMLHttpRequest' } });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || this.dataset.error);
          added = true;
          status.textContent = this.dataset.added;
          button.textContent = this.dataset.added;
          if (window.themeVariables?.settings?.cartType === 'page') { location.href = root + 'cart'; return; }
          const cartResponse = await fetch(root + 'cart.js');
          if (!cartResponse.ok) throw new Error();
          const cart = await cartResponse.json();
          cart.sections = result.sections;
          if (sections.some(id => !cart.sections?.[id])) {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          } else {
            document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart } }));
            document.documentElement.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: result.items || [result], cart } }));
          }
        } catch (error) {
          if (added) {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          } else {
            status.textContent = error.message || this.dataset.error;
            button.disabled = false;
            button.textContent = originalLabel;
          }
        } finally {
          this.adding = false;
          button.removeAttribute('aria-busy');
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mcs-wishlist"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mcs-wishlist')) {
    customElements.define('mcs-wishlist', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.key = 'mcs.wishlist.v1';
        this.list = 'wishlist';
        this.limit = 12;
        this.state = [];
        this.cache = new Map();
        this.strings = Object.fromEntries(Array.from(this.querySelectorAll('[data-key]')).map(n => [n.dataset.key,n.textContent]));
        this.dialog = this.querySelector('dialog');
        this.root = (this.dataset.root || '/').replace(/\/?$/, '/');
        this.read();
        const options = {signal:this.controller.signal};
        document.addEventListener('click', e => this.click(e), options);
        document.addEventListener('variant:change', e => {
          document.querySelectorAll('[data-product-form]').forEach(b => { if (b.dataset.productForm === e.detail?.formId && e.detail?.variant?.id) b.dataset.variantId = String(e.detail.variant.id); });
          this.updateButtons();
        }, options);
        document.addEventListener('change', e => { const card=e.target.closest('product-card'); if(card) requestAnimationFrame(()=>this.updateButtons(card)); }, options);
        window.addEventListener('storage', e => { if(e.key===this.key){this.read();this.updateButtons();if(this.dialog.open)this.render();} }, options);
        this.dialog.addEventListener('close',()=>{document.body.style.overflow=this.oldOverflow||'';if(this.opener?.isConnected)this.opener.focus({preventScroll:true});},options);
        this.dialog.addEventListener('click',e=>{const r=this.dialog.getBoundingClientRect();if(e.target===this.dialog&&(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom))this.dialog.close();},options);
        this.querySelector('[role="tablist"]').addEventListener('keydown',e=>{if(['ArrowLeft','ArrowRight','Home','End'].includes(e.key)){e.preventDefault();this.selectList(e.key==='Home'?'wishlist':e.key==='End'?'later':this.list==='wishlist'?'later':'wishlist');this.querySelector('[aria-selected="true"]').focus();}},options);
        this.querySelector('[data-wish-file]').addEventListener('change',e=>this.importFile(e),options);
        this.observer = new MutationObserver(records=>{for(const record of records)for(const node of record.addedNodes){if(node.nodeType===1&&(node.matches?.('[data-mcs-save],[data-mcs-wish-count]')||node.querySelector?.('[data-mcs-save],[data-mcs-wish-count]')))this.updateButtons(node);}});
        this.observer.observe(document.body,{childList:true,subtree:true});
        this.updateButtons();
        const hash=location.hash;
        if(hash.startsWith('#mcs-wishlist=')){
          try {this.pending=this.parseTransfer(JSON.parse(new TextDecoder().decode(Uint8Array.from(atob(hash.slice(14).replace(/-/g,'+').replace(/_/g,'/')),c=>c.charCodeAt(0)))));this.querySelector('[data-wish-shared]').hidden=false;this.querySelector('[data-shared-count]').textContent=String(this.pending.length);this.open();}
          catch{this.notify(this.strings.invalid_import);}
        }else if(['#swym-wishlist','#wishlist'].includes(hash)||/\/pages\/(swym-wishlist|wishlist|wish-list)\/?$/.test(location.pathname))this.open();
      }
      disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();clearTimeout(this.toastTimer);if(this.exportUrl)URL.revokeObjectURL(this.exportUrl);}
      normalize(raw,transfer=false){
        if(!raw||typeof raw!=='object'||typeof raw.handle!=='string'||!/^[-a-z0-9]{1,180}$/.test(raw.handle))throw new Error(this.strings.invalid_import);
        const variantId=String(raw.variantId||'');
        if(!/^\d{1,20}$/.test(variantId))throw new Error(this.strings.invalid_import);
        const quantity=Number(raw.quantity??1);if(!Number.isInteger(quantity)||quantity<1||quantity>99)throw new Error(this.strings.invalid_import);
        const title=typeof raw.title==='string'?raw.title.slice(0,500):raw.handle.replace(/-/g,' ');
        let image='';try{if(typeof raw.image==='string'&&raw.image.trim()){const u=new URL(raw.image,location.origin);if(u.protocol==='https:'&&[location.hostname,'cdn.shopify.com',this.dataset.shopHost].includes(u.hostname))image=u.href;}}catch{}
        return{handle:raw.handle,variantId,productId:String(raw.productId||'').slice(0,20),title,image,list:raw.list==='later'?'later':'wishlist',quantity,restore:!transfer&&raw.restore===true,addedAt:Number.isFinite(raw.addedAt)?raw.addedAt:Date.now()};
      }
      id(item){return item.handle+':'+item.variantId;}
      read(){
        try{const raw=localStorage.getItem(this.key);if(!raw){this.state=[];this.storageIssue=false;return;}const d=JSON.parse(raw);if(d.version!==1||!Array.isArray(d.items)||d.items.length>100)throw new Error();this.state=d.items.map(i=>this.normalize(i));this.storageIssue=false;}
        catch{this.storageIssue=true;}
      }
      commit(items){
        if(this.storageIssue)throw new Error(this.strings.storage_error);
        if(items.length>100)throw new Error(this.strings.limit);
        const next={version:1,items:items.map(i=>this.normalize(i))};
        try{localStorage.setItem(this.key,JSON.stringify(next));}catch{throw new Error(this.strings.storage_error);}
        this.state=next.items;this.updateButtons();document.dispatchEvent(new CustomEvent('mcs:wishlist:change',{detail:{count:this.state.length}}));
      }
      upsert(item){this.read();const items=this.state.filter(i=>this.id(i)!==this.id(item));items.unshift(item);this.commit(items);}
      remove(key){this.read();this.commit(this.state.filter(i=>this.id(i)!==key));}
      buttonItem(button){
        let variantId=button.dataset.variantId;
        const form=button.dataset.productForm?document.getElementById(button.dataset.productForm):null;
        if(form?.elements?.namedItem('id')?.value)variantId=form.elements.namedItem('id').value;
        const card=button.closest('product-card');
        if(card){try{variantId=new URL(card.querySelector('.product-card__figure > a')?.href).searchParams.get('variant')||variantId;}catch{}}
        return this.normalize({handle:button.dataset.handle,variantId,productId:button.dataset.productId,title:button.dataset.title,image:button.dataset.image,list:button.dataset.saveList||'wishlist',quantity:Number(button.dataset.quantity||1),restore:Boolean(button.dataset.cartKey),addedAt:Date.now()});
      }
      updateButtons(root=document){
        const buttons=[...(root.matches?.('[data-mcs-save]')?[root]:[]),...root.querySelectorAll('[data-mcs-save]')];
        for(const b of buttons){try{const item=this.buttonItem(b);if(!b.dataset.saveList){const saved=this.state.some(i=>this.id(i)===this.id(item));b.setAttribute('aria-pressed',String(saved));b.querySelector('[data-save-label]')?.replaceChildren(document.createTextNode(saved?this.strings.saved:this.strings.save));}}catch{}}
        document.querySelectorAll('[data-mcs-wish-count]').forEach(n=>{n.textContent=String(this.state.length);n.hidden=!this.state.length;});
        this.querySelectorAll('[data-list-count]').forEach(n=>{n.textContent=String(this.state.filter(i=>i.list===n.dataset.listCount).length);});
      }
      async click(event){
        const target=event.target.closest('button,a');if(!target)return;
        if(target.matches('[data-mcs-save]')){event.preventDefault();await this.save(target);return;}
        if(target.matches('[data-mcs-wish-open]')||target.getAttribute('href')==='#swym-wishlist'){event.preventDefault();this.open(target);return;}
        if(!this.contains(target))return;
        if(target.matches('[data-wish-close]'))this.dialog.close();
        else if(target.matches('[data-toast-close]'))this.querySelector('[data-wish-toast]').hidden=true;
        else if(target.matches('[data-wish-tab]'))this.selectList(target.dataset.wishTab);
        else if(target.matches('[data-wish-more]')){this.limit+=12;this.render();}
        else if(target.matches('[data-wish-remove]')){try{this.remove(target.closest('[data-wish-key]').dataset.wishKey);this.render();this.status(this.strings.removed);}catch(e){this.status(e.message);}}
        else if(target.matches('[data-wish-restore]'))await this.restore(target);
        else if(target.matches('[data-wish-export]'))this.export();
        else if(target.matches('[data-wish-share]'))await this.share();
        else if(target.matches('[data-wish-import]'))this.querySelector('[data-wish-file]').click();
        else if(target.matches('[data-wish-accept]')){try{this.merge(this.pending);this.pending=null;this.querySelector('[data-wish-shared]').hidden=true;this.selectList('wishlist');this.status(this.strings.imported);}catch(e){this.status(e.message);}}
        else if(target.matches('[data-wish-dismiss]')){this.pending=null;this.querySelector('[data-wish-shared]').hidden=true;}
      }
      async save(button){
        if(this.busy)return;this.busy=true;button.disabled=true;
        try{
          const item=this.buttonItem(button);
          this.read();
          if(!button.dataset.saveList&&this.state.some(i=>this.id(i)===this.id(item))){this.remove(this.id(item));this.notify(this.strings.removed);return;}
          this.upsert(item);
          if(button.dataset.cartKey){
            try{await this.cartMutation('change',{id:button.dataset.cartKey,quantity:0});this.notify(this.strings.saved_later);if(location.pathname===this.root+'cart')location.reload();}
            catch{this.notify(this.strings.cart_error);}
          }else this.notify(button.dataset.saveList?this.strings.saved_copy:this.strings.saved);
          if(this.dialog.open)this.render();
        }catch(e){this.notify(e.message||this.strings.storage_error);}
        finally{this.busy=false;button.disabled=false;}
      }
      open(opener){
        this.opener=opener||document.activeElement;this.read();this.updateButtons();this.cache.clear();this.status('');
        if(!this.dialog.open){this.oldOverflow=document.body.style.overflow;this.dialog.showModal();document.body.style.overflow='hidden';}
        this.querySelector('[data-wish-toast]').hidden=true;this.render();if(this.storageIssue)this.status(this.strings.storage_error);
      }
      selectList(list){this.list=list;this.limit=12;this.querySelectorAll('[data-wish-tab]').forEach(b=>{const selected=b.dataset.wishTab===list;b.setAttribute('aria-selected',String(selected));b.tabIndex=selected?0:-1;});this.querySelector('[role="tabpanel"]').setAttribute('aria-labelledby',list==='wishlist'?'mcs-wish-tab':'mcs-later-tab');this.status('');this.render();}
      status(text){this.querySelector('[data-wish-status]').textContent=text;}
      notify(text){if(this.dialog.open){this.status(text);return;}const box=this.querySelector('[data-wish-toast]');this.querySelector('[data-wish-toast-text]').textContent=text;box.hidden=false;clearTimeout(this.toastTimer);this.toastTimer=setTimeout(()=>{box.hidden=true;},7000);}
      fallback(item,loading=false){
        const article=document.createElement('article');article.className='mcs-wish-item';article.dataset.wishKey=this.id(item);
        const href=this.root+'products/'+item.handle+'?variant='+item.variantId;
        const link=document.createElement('a');link.href=href;link.className='mcs-wish-item__image';if(item.image){const img=document.createElement('img');img.src=item.image;img.alt=item.title;img.width=96;img.height=96;img.loading='lazy';link.append(img);}article.append(link);
        const body=document.createElement('div');body.className='mcs-wish-item__body';const title=document.createElement('a');title.href=href;title.textContent=item.title;title.className='mcs-wish-item__title';body.append(title);
        const message=document.createElement('p');message.className='mcs-wish-item__message';message.textContent=loading?this.strings.loading:this.strings.load_error;body.append(message);
        const actions=document.createElement('div');actions.className='mcs-wish-item__actions';const view=document.createElement('a');view.href=href;view.className='mcs-wish-button';view.textContent=this.strings.view_options;actions.append(view);const remove=document.createElement('button');remove.type='button';remove.dataset.wishRemove='';remove.className='mcs-wish-text-button';remove.textContent=this.strings.remove;actions.append(remove);body.append(actions);article.append(body);return article;
      }
      async render(){
        const generation=this.generation=(this.generation||0)+1;const items=this.state.filter(i=>i.list===this.list);const visible=items.slice(0,this.limit);const container=this.querySelector('[data-wish-items]');
        container.replaceChildren(...visible.map(i=>this.fallback(i,true)));this.querySelector('[data-wish-empty]').hidden=items.length>0;this.querySelector('[data-wish-empty-text]').textContent=this.list==='later'?this.strings.later_empty:this.strings.empty_text;this.querySelector('[data-wish-more]').hidden=items.length<=this.limit;
        let index=0;const worker=async()=>{while(index<visible.length){const item=visible[index++],key=this.id(item);let article;
          try{let html=this.cache.get(key);if(!html){const url=new URL(this.root+'products/'+item.handle,location.origin);url.searchParams.set('variant',item.variantId);url.searchParams.set('section_id','mcs-wishlist-item');const response=await fetch(url,{signal:this.controller.signal});if(!response.ok)throw new Error();html=await response.text();this.cache.set(key,html);}
            article=new DOMParser().parseFromString(html,'text/html').querySelector('[data-wish-item]');if(!article)throw new Error();article.dataset.wishKey=key;
            const exact=article.dataset.variantId===item.variantId;const restore=article.querySelector('[data-wish-restore]');restore.hidden=!(item.list==='later'&&item.restore&&exact&&article.dataset.available==='true'&&article.dataset.requiresPlan!=='true');
            if(!exact)article.querySelector('[data-item-message]').textContent=this.strings.unavailable;
            if(item.quantity>1){const p=document.createElement('p');p.className='mcs-wish-item__variant';p.textContent=this.strings.quantity+': '+item.quantity;article.querySelector('.mcs-wish-item__body').append(p);}
          }catch{article=this.fallback(item);}
          if(generation!==this.generation)return;const old=Array.from(container.children).find(n=>n.dataset.wishKey===key);if(old)old.replaceWith(article);
        }};await Promise.all([worker(),worker(),worker()]);
      }
      async cartMutation(action,payload){
        const sections=['variant-added'];document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections',{bubbles:true,detail:{sections}}));
        const response=await fetch(this.root+'cart/'+action+'.js',{method:'POST',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({...payload,sections:[...new Set(sections)].slice(0,5),sections_url:location.pathname})});
        const result=await response.json();if(!response.ok)throw new Error(result.description||this.strings.cart_error);
        let cart=result;
        try{if(action==='add'){const r=await fetch(this.root+'cart.js');if(!r.ok)throw new Error();cart=await r.json();cart.sections=result.sections;}
          if(sections.some(id=>!cart.sections?.[id]))throw new Error();
          document.documentElement.dispatchEvent(new CustomEvent('cart:change',{bubbles:true,detail:{baseEvent:action==='add'?'variant:add':'line-item:change',cart}}));
          if(action==='add')document.documentElement.dispatchEvent(new CustomEvent('variant:add',{bubbles:true,detail:{items:result.items||[result],cart,blockCartDrawerOpening:true}}));
        }catch{document.dispatchEvent(new CustomEvent('cart:refresh'));}
        return cart;
      }
      async restore(button){
        if(this.busy)return;const key=button.closest('[data-wish-key]').dataset.wishKey;const item=this.state.find(i=>this.id(i)===key);if(!item?.restore)return;this.busy=true;button.disabled=true;button.setAttribute('aria-busy','true');
        let added=false;
        try{this.upsert({...item,restore:false});await this.cartMutation('add',{items:[{id:item.variantId,quantity:item.quantity}]});added=true;this.remove(key);this.render();this.status(this.strings.added_cart);if(location.pathname===this.root+'cart')location.reload();}
        catch(e){this.render();this.status(added?this.strings.added_cart+'. '+this.strings.storage_error:(e.message||this.strings.cart_error));}
        finally{this.busy=false;button.disabled=false;button.removeAttribute('aria-busy');}
      }
      transfer(){return{version:1,items:this.state.filter(i=>i.list===this.list).map(({handle,variantId,quantity})=>({handle,variantId,quantity}))};}
      parseTransfer(data){if(data?.version!==1||!Array.isArray(data.items)||data.items.length>100)throw new Error(this.strings.invalid_import);return data.items.map(i=>this.normalize(i,true));}
      merge(items){this.read();const merged=new Map(this.state.map(i=>[this.id(i),i]));for(const item of items)if(!merged.has(this.id(item)))merged.set(this.id(item),item);this.commit([...merged.values()]);}
      export(){const data=this.transfer();if(!data.items.length){this.status(this.strings.no_share);return;}if(this.exportUrl)URL.revokeObjectURL(this.exportUrl);this.exportUrl=URL.createObjectURL(new Blob([JSON.stringify(data,null,2)],{type:'application/json'}));const a=this.querySelector('[data-wish-download]');a.href=this.exportUrl;a.download='My-Chess-Sets-Wishlist.json';a.hidden=false;a.click();this.status(this.strings.export_ready);}
      async share(){const data=this.transfer();if(!data.items.length){this.status(this.strings.no_share);return;}const encoded=btoa(String.fromCharCode(...new TextEncoder().encode(JSON.stringify(data)))).replace(/\+/g,'-').replace(/\//g,'_').replace(/=+$/,'');const url=new URL(this.root,location.origin);url.hash='mcs-wishlist='+encoded;this.querySelector('[data-wish-link-box]').hidden=false;this.querySelector('[data-wish-link]').value=url.href;try{await navigator.clipboard.writeText(url.href);this.status(this.strings.copied);}catch{this.querySelector('[data-wish-link]').select();}}
      async importFile(event){const file=event.target.files?.[0];event.target.value='';if(!file)return;try{if(file.size>150000)throw new Error();const items=this.parseTransfer(JSON.parse(await file.text()));this.merge(items);this.selectList('wishlist');this.status(this.strings.imported);}catch(e){this.status(e.message===this.strings.limit||e.message===this.strings.storage_error?e.message:this.strings.invalid_import);}}
    });
  }
  } catch(e) { console.error(e); }
})();

})();
